import { useQuery } from "@tanstack/react-query";

export type StruggleWord = {
  id: number;
  word: string;
  sentence: string;
  word_language: string;
  translation: string;
  translation_language: string;
};

export function useStruggleWords(language?: string) {
  return useQuery({
    queryKey: ["struggle-words", language ?? "ALL"],
    queryFn: async () => {
      const params =
        language && language !== "ALL"
          ? `?language=${encodeURIComponent(language)}`
          : "";
      const res = await fetch(`/api/reeprise/vocabulary/struggle_words/${params}`);
      if (!res.ok) {
        throw new Error("Failed to load struggle words");
      }
      return (await res.json()) as StruggleWord[];
    },
    staleTime: 24 * 60 * 60 * 1000, // refresh at most once per day
    refetchInterval: 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
